import CompanySize from '@/types/company-size'

import type {CountryCode} from '@/locale/locales'

interface googleConversionValuesType {
    countryCodes: CountryCode[]
    values: {
        small: number
        medium: number
        large: number
    }
    currency: string
}

// Country/Size values as taken from https://www.notion.so/pleo/Google-Conversion-Values-f0aa423b6b724965a427a405991cb42d
const googleAdsConversionValues: googleConversionValuesType[] = [
    {
        countryCodes: ['gb', 'ie'],
        values: {
            small: 278,
            medium: 526,
            large: 1157,
        },
        currency: 'EUR',
    },
    {
        countryCodes: ['dk'],
        values: {
            small: 260,
            medium: 584,
            large: 1105,
        },
        currency: 'EUR',
    },
    {
        countryCodes: ['de'],
        values: {
            small: 215,
            medium: 464,
            large: 1092,
        },
        currency: 'EUR',
    },
    {
        countryCodes: ['se'],
        values: {
            small: 229,
            medium: 623,
            large: 2175,
        },
        currency: 'EUR',
    },
    {
        countryCodes: ['es'],
        values: {
            small: 239,
            medium: 599,
            large: 875,
        },
        currency: 'EUR',
    },
    {
        countryCodes: ['nl', 'be', 'fr', 'at', 'fi', 'lu', 'pt', 'ee', 'it', 'no'],
        values: {
            small: 230,
            medium: 584,
            large: 1105,
        },
        currency: 'EUR',
    },
]

export const getConversionValues = (companySize: CompanySize, country: CountryCode) => {
    const countryValues = googleAdsConversionValues.find((item) =>
        item.countryCodes.includes(country),
    )

    if (!countryValues) {
        return
    }

    switch (companySize) {
        case CompanySize.Size_1:
        case CompanySize.Size_2:
        case CompanySize.Size_5:
            return {
                value: countryValues.values.small,
                currency: countryValues.currency,
            }
        case CompanySize.Size_10:
            return {
                value: countryValues.values.medium,
                currency: countryValues.currency,
            }
        case CompanySize.Size_50:
        case CompanySize.Size_100:
        case CompanySize.Size_250:
        case CompanySize.Size_500:
            return {
                value: countryValues.values.large,
                currency: countryValues.currency,
            }
        default:
            return
    }
}
